// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Gtb8","head":"Table_head__qRYc-","col":"Table_col__2jxK6"};